import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CompanyService }      from '../companies/company.service';
import { CustomerModel }      from '../customers/models/customer';
import { SelectOption }        from '../core/models/select-option';
import { SessionCompanyModel } from '../sessions/models/session.company';
import { SessionService }      from '../sessions/session.service';
import { VehicleModel }        from './models/vehicle';

@Component({
  selector   : 'wor-vehicle-form-marine',
  template: require('./vehicle.form-marine.component.html')
})
export class VehicleFormMarineComponent {
  @Input() vehicle: VehicleModel;
  @Input() company: SessionCompanyModel;
  @Input() customer: CustomerModel;
  @Input() body_types: SelectOption[];
  @Input() body_types_limited: SelectOption[];
  @Input() transmission_types: SelectOption[];
  @Input() fuel_types: SelectOption[];
  @Input() hull_types: SelectOption[];
  @Input() hull_material_types: SelectOption[];
  @Input() regoLabel: string;
  @Input() isKiwi: boolean;
  @Input() plateDuplicate: boolean;
  @Input() vinDuplicate: boolean;

  @Output() onCheckPlate = new EventEmitter<void>();
  @Output() onDelete     = new EventEmitter<void>();
  @Output() onArchive    = new EventEmitter<void>();

  constructor(
    public companyService: CompanyService,
    public sessionService: SessionService
  ) {}

  canUnarchiveVehicle (): boolean {


    return this.vehicle.id
      && this.vehicle.archived
      && !this.customer.archived;


  }
}
